<h2 mat-dialog-title>Profile</h2>
<mat-dialog-content>

  <ng-template #loading>
    <mat-progress-bar mode="query"></mat-progress-bar>
  </ng-template>

  <div *ngIf="vm$ | async as vm; else loading">
    <ng-container *ngFor="let agrupador of vm.agrupadores">
      <div [class]="agrupador.clase">
        <div class="title-group">
          <!-- <mat-icon>{{ agrupador.icono }}</mat-icon> -->
          <h1>{{ agrupador.nombre }}</h1>
          <div class="h1-line"></div>
        </div>

        <ng-container *ngFor="let categoria of agrupador.items">
          <div class="title-group">
            <!-- <mat-icon class="mat-icons mat-icon-rounded" [ngClass]="categoria.nickname + '-icon'">{{ categoria.icono}}</mat-icon> -->
            <h2>{{ categoria.nombre }}</h2>
          </div>
          <p>{{ categoria.descriptor }}</p>
          <mat-accordion *ngFor="let unidadMeta of vm.metas" multi>
            <mat-expansion-panel *ngIf="unidadMeta.meta.categoriaId === categoria.id"
              class="mat-expansion-panels margin_panel" [ngClass]="categoria.nickname + '-panel'" closed="true">
              <mat-expansion-panel-header color="primary">
                <mat-panel-description>
                  {{ unidadMeta.meta.nombre }}
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div>
                <app-criterios *ngIf="unidadMeta.meta.criterios" [criterios]="unidadMeta.meta.criterios">
                </app-criterios>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
